import styles from "./style.module.css";
import 'react-loading-skeleton/dist/skeleton.css'

const Spinner = () => {


    return (<span className={styles.loader}></span>)
}

export default Spinner